import React from 'react'
import { useState } from 'react';  
import MemberCountExcel from './MemberCountExcel'
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import GetDistricts from'../../Dropdowns/getAllDistricts';
import GetAfsoo from "../../Dropdowns/getAfsoAll";


function MemberCount_Int({ heading }) {
    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true); // Manage loading state
     const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [selectedDist, setSelectedDist] = useState('');
      const [selectedAfso, setSelectedAfso] = useState("");
        const [loadingAfso, setLoadingAfso] = useState(false);
      
    
    
    const handleDistrictChange = (dist_code) => {
        setSelectedDist(dist_code);
       };
    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };


  const handleAfsoChange = (afso_code) => {
    setSelectedAfso(afso_code);
  };
  
    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
        const dist_code = document.getElementById('dist_code').value;
  let afso_code = "0";
  if (dist_code !== "0" && dist_code.toLowerCase() !== "all") {
    afso_code = document.getElementById('afso_code').value;
  }

        if (!month || month == 0 || month == null || month == '') {
            alert('Please select Month');
        } else if (!year || year == 0 || year == null || year == '') {
            alert('Please select Year');
        } else if (!dist_code ||  dist_code == null || dist_code == '') {
            alert('Please select District');
        }
      else if (!afso_code ||  afso_code == null) {
      alert(" Please select an AFSO.");
        } else {
            setRenderContent(null);
            setTimeout(() => {
                setRenderContent(
                    <MemberCountExcel
                        month={month}
                        year={year}
                        dist_code = {dist_code}
                        afso_code={afso_code}
                        heading={heading}
                    />
                );
            }, 0);
        }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="50%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={10}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleLoadingChange} /></td>
                                    <td>District</td>
                  <td>
                    <GetDistricts
                      onLoadingChange={setLoadingDistricts}
                      onChange={handleDistrictChange}
                    />
                  </td>
                       <td>AFSO</td>
                <td>
                  {selectedDist ? (
                    <GetAfsoo
                      dist_code={selectedDist}
                      onLoadingChange={setLoadingAfso}
                      onChange={handleAfsoChange}
                    />
                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td>
                                </tr>
                                <tr>
                                    <td colSpan={10} align="center">
                                        <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default MemberCount_Int